import portalApi from '../api/portalApi';

export const portalFetcher = async (url: string) => {
  const response = await portalApi.get(url);
  return response.data;
};
